<template>
  <v-container>
    <NotRegistered v-if="isLoggedIn && ! isRegistered" />
    <LoggedIn v-else-if="isLoggedIn && isRegistered" />
    <LoggedOut v-else />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import LoggedOut from "@/components/Start/LoggedOut"
import LoggedIn from "@/components/Start/LoggedIn"
import NotRegistered from "@/components/Start/NotRegistered"

export default {
  name: "Start",

  components: {
    LoggedOut,
    NotRegistered,
    LoggedIn
  },

  computed: {
    ...mapGetters("currentuser", ["currentUser","isLoggedIn","isRegistered"]),
  },

  created () {
    console.log("Start - created");
  }  
};
</script>

<style>
</style>            